import type { CustomMessageShowType } from '../enums/CustomMessageShowType'
import type { Language } from '@/shared/enums/languagesEnum'
import type { CustomMessageTranslationEntity } from './CustomMessageTranslationEntity'
import type { CustomMessageButtonEntity } from './CustomMessageButtonEntity'
import type { UserAppType } from '../enums/UserAppType'

export class CustomMessageEntity {
  id?: number
  showType?: CustomMessageShowType
  imageUrl?: string | null
  buttons?: CustomMessageButtonEntity[] | null
  translations?: CustomMessageTranslationEntity[] | null
  isEnabled?: boolean
  startDate?: string 
  expirationDate?: string | null
  languages?: Language[] | null
  userAppTypes?: UserAppType[] | null
}
